export const FinanceDemoColumns = [  
  { field: 'institution', headerName: 'Institution', width: 180, editable: false, sortable: false },  
  { field: 'assetClass', headerName: 'Domain', width: 180, editable: false, sortable: false },  
  { field: 'orderStatus', headerName: 'Status', width: 180, editable: false, sortable: false },  
  { field: 'softwareVersion', headerName: 'Version', width: 180, editable: false, sortable: false },  
  { field: 'tradeVolume', headerName: 'Trade Volume', width: 180, editable: false, sortable: false },  
  { field: 'tradeDate', headerName: 'Trade Date', width: 180, editable: false, sortable: false },  
  { field: 'tradeType', headerName: 'Trade Type', width: 180, editable: false, sortable: false },  
];  

export const FinanceDemoRows = [  
  {  
      id: 1,  
      institution: "RBC",  
      tradeType: "marketOrder",  
      assetClass: "equities",  
      tradeVolume: "10",  
      softwareVersion: "v1.2",  
      tradeDate: "2024-01-15",  
      orderStatus: "completed",  
  },  
  {  
      id: 2,  
      tradeType: "stopOrder",  
      assetClass: "etf",  
      tradeVolume: "5",  
      softwareVersion: ">",  
      tradeDate: "2024-01-16", 
      orderStatus: "pending",  
 
  },  
  {  
      id: 3,  
      tradeType: "short",  
      assetClass: "options",  
      tradeVolume: "8",  
      softwareVersion: "v1.4",  
      tradeDate: "2024-01-17",  
      orderStatus: "canceled",  

  },  
  {  
      id: 4,  
      tradeType: "*",  
      assetClass: "bonds",  
      tradeVolume: "*",  
      softwareVersion: "v1.5",  
      tradeDate: "*",  
      orderStatus: "failed",  

  },  
  {  
      id: 5,  
      tradeType: "stopLimitOrder",  
      assetClass: "mutualFunds",  
      tradeVolume: "15",  
      tradeDate: "2024-01-19",  
  },  
  {  
      id: 6,  
      tradeType: "gtc",  
      assetClass: "commodities",  
      tradeVolume: "7",  
      tradeDate: "2024-01-20",  
  },  
  {  
      id: 7,  
      tradeType: "conditionalOrder",  
      tradeVolume: "12",  
      tradeDate: "2024-01-21",  
  },  
  {  
      id: 8,  
      tradeVolume: "20", 
      tradeDate: "2024-01-22",  
 
  },  
  {  
      id: 9,  
      tradeDate: "2024-01-23",  
  },  
  {  
      id: 10,  
      tradeDate: "2024-01-24",  
  },  
];
